export enum ProcessStepStage{
    start,
    end,
    action
}